import React from "react";
import AppointmentListing from "./AppointmentListing";

const AppointmentDetails = () => {

  return (
    <>
      <AppointmentListing
      />
    </>
  );
};
export default AppointmentDetails;
